import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PortalNewAffiliateObj, ValidationResponseObj} from 'mx-core';
import {DataValidator} from '../../../../shared/services/data-validator';

const SIGNUP_URL: string = '/rest/signup';

@Injectable({
    providedIn: 'root'
})
export class PrlAffiliatesDataService implements DataValidator<PortalNewAffiliateObj> {

    constructor(private httpClient: HttpClient) {
    }

    validate(affiliateObj: PortalNewAffiliateObj, _url: string): Observable<ValidationResponseObj | null> {
        return this.httpClient.post<null | ValidationResponseObj>(SIGNUP_URL + '/validate', affiliateObj);
    }

    activate(userName: string, hash: string): Observable<boolean> {
        return this.httpClient.get<boolean>(SIGNUP_URL + '/activate/' + userName + "/" + hash);
    }
}
